import OnboardingDialogLayout from "@components/layouts/Onboarding/components/OnboardDialogLayout";
import { LoginPP } from "@components/utils/Auth";
import { OnboardingDialogStep } from "@components/utils/OnboardingDialog/constants";
import { OnboardingStepProps } from "@components/utils/OnboardingDialog/types";
import { usePostLoginHandler } from "@hooks/usePostLoginHandler";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
interface LoginStepProps extends OnboardingStepProps {}

const LoginStep = ({ navigate, handleClose, layout }: LoginStepProps) => {
  const { t } = useTranslation();
  const { loginFlowHandlers } = usePostLoginHandler({
    flowMode: "dialog",
  });

  const handleForgotSecret = useCallback(() => {
    navigate(OnboardingDialogStep.ForgotSecret);
  }, [navigate]);

  return (
    <OnboardingDialogLayout
      layout={layout}
      pageTitle={t("Login")}
      navigation={{
        close: {
          onClick: handleClose,
        },
        back: {
          onClick: () => navigate(OnboardingDialogStep.Onboarding),
        },
      }}
      features={{
        showCloseButton: true,
        showBackButton: true,
      }}
    >
      <LoginPP
        onForgotSecret={handleForgotSecret}
        onLoginSuccess={loginFlowHandlers.handleLoginSuccess}
      />
    </OnboardingDialogLayout>
  );
};

export default LoginStep;
